const generatePassword = () => {
  // Define character sets for each requirement
  const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
  const digits = "0123456789";
  const specialCharacters = '~!@#$%^*()_-{}[]";:<>?.+';

  // Generate a password by randomly selecting characters from each set
  const password =
    getRandomChar(uppercaseLetters) +
    getRandomChar(lowercaseLetters) +
    getRandomChar(digits) +
    getRandomChar(specialCharacters) +
    getRandomChars(
      uppercaseLetters + lowercaseLetters + digits + specialCharacters,
      8
    );

  // Shuffle the password to make the order random
  const shuffledPassword = shuffleString(password);

  return shuffledPassword;
};

const getRandomChar = (characters: string) => {
  return characters.charAt(Math.floor(Math.random() * characters.length));
};

const getRandomChars = (characters: string, count: number) => {
  let randomChars = "";
  for (let i = 0; i < count; i++) {
    randomChars += getRandomChar(characters);
  }
  return randomChars;
};

const shuffleString = (str: string) => {
  const array = str.split("");
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array.join("");
};

export default generatePassword;
